import { render } from "./ObjectiveExtract.vue?vue&type=template&id=57f494ae&scoped=true"
import script from "./ObjectiveExtract.vue?vue&type=script&lang=js"
export * from "./ObjectiveExtract.vue?vue&type=script&lang=js"

import "./ObjectiveExtract.vue?vue&type=style&index=0&id=57f494ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f494ae"]])

export default __exports__